import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BASE } from '@client-hub/shared/constants/routes'
import { useGetClientBrandingQuery } from '@client-hub/store/api/gcs/augmented'
import { MfaNavigateState } from 'components/Mfa/Auth'

export const useRedirect = (enable: boolean, path = BASE) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (enable) navigate(path)
  }, [enable, path, navigate])
}

export const useMfaNavigateState = () => {
  const location = useLocation()
  const state = (location.state as MfaNavigateState) || { state: {} }

  return state
}

export const useLogoSrcUrl = (variant: 'default' | 'dark' = 'default') => {
  const { data } = useGetClientBrandingQuery()
  const logo = data?.branding?.themeUrls?.logo
  const logoDark = data?.branding?.themeUrls?.logoDark
  const logoSrc = variant === 'default' ? logo : logoDark
  return logoSrc
}
